import { HttpResponse } from 'msw';

/** DHCP relay/inserter/remote id — match legacy fallback when GET has no specific payload. */
export function dhcpExtendedBlock(
  access: string,
  command: string,
): ReturnType<typeof HttpResponse.json> | null {
  const match =
    command.includes('subnet') ||
    command.includes('leases') ||
    command.includes('relay') ||
    command.includes('inserter') ||
    command === 'remote id' ||
    command === 'server id override';
  if (!match) return null;

  if (access === 'get') {
    switch (command) {
      case 'relay settings':
        return HttpResponse.json(
          {
            server_id_override: false,
            subnets: [
              {
                vid: 0,
                servers: [{ address: '192.168.1.2', port: 67 }],
                ports: { P1: 'circuit-1', P2: 'circuit-2', P3: '' },
              },
              {
                vid: 10,
                servers: [{ address: '10.0.10.2', port: 67 }],
                ports: { P1: '', P2: '', P3: 'uplink-10' },
              },
            ],
          },
          { status: 200 },
        );
      case 'inserter settings':
        return HttpResponse.json(
          {
            subnets: [
              {
                vid: 0,
                ports: [
                  { port_id: 0, circuit_id: 'CPID-1' },
                  { port_id: 1, circuit_id: 'CPID-2' },
                  { port_id: 2, circuit_id: '' },
                ],
              },
              {
                vid: 10,
                ports: [
                  { port_id: 0, circuit_id: '' },
                  { port_id: 1, circuit_id: 'CPID-10-2' },
                ],
              },
            ],
          },
          { status: 200 },
        );
      case 'remote id':
        return HttpResponse.json(
          { remote_type: 0, remote_id: 'relay-id' },
          { status: 200 },
        );
      case 'server id override':
        return HttpResponse.json(
          { server_id_override: false },
          { status: 200 },
        );
      default:
        return HttpResponse.json({ ok: true }, { status: 200 });
    }
  }

  return HttpResponse.json({ ok: true }, { status: 200 });
}
